import { Node as f } from "@tiptap/core";
import { VueNodeViewRenderer as u } from "@tiptap/vue-3";
function c({
  name: r,
  tagName: t,
  draggable: i,
  vueComponent: d,
  addAttributes: a,
  addCommands: s
}, n = {}) {
  return f.create({
    name: r,
    draggable: i,
    addAttributes: a,
    addCommands: s,
    addNodeView() {
      return u(d);
    },
    /** For HTML we just render a placeholder element with the serialized attributes */
    renderHTML({ node: e }) {
      return e.isLeaf ? [t || r, { "data-attrs": JSON.stringify(e.attrs) }] : [t || r, { "data-attrs": JSON.stringify(e.attrs) }, 0];
    },
    ...n
  });
}
function y({
  name: r,
  tagName: t,
  baseNode: i,
  draggable: d,
  vueComponent: a,
  addCommands: s,
  addAttributes: n
}, e = {}) {
  return i.extend({
    draggable: d,
    addAttributes: n,
    addCommands: s,
    addNodeView() {
      return u(a);
    },
    /** For HTML we just render a placeholder element with the serialized attributes */
    renderHTML({ node: o }) {
      return o.isLeaf ? [t || r, { "data-attrs": JSON.stringify(o.attrs) }] : [t || r, { "data-attrs": JSON.stringify(o.attrs) }, 0];
    },
    ...e
  });
}
export {
  c as createEditorVueNode,
  y as extendEditorVueNode
};
